import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 是否开通校园大屏
  judgeOpenScreen(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_JUDGE_OPEN_SCREEN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询机构投屏列表
  getScreenListByOrgId(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCREEN_LIST_BY_ORG_ID, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 生成uid
  generateUid(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GENERATE_UID, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 投屏断开连接
  disconnectScreen(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DISCONNECT_SCREEN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 扫码登陆
  scanLogin(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCAN_LOGIN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通过uid查询token
  getUidByToken(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_UID_BY_TOKEN, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 大屏列表
  list(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_LIST, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 投屏更换视图
  screenChangeView(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SCREEN_CHANGE_VIEW, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 生成二维码
  genQrCode(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_GET_OR_CODE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通过uid查询投屏id
  getScreenIdByUid(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCREEN_ID_BY_UID, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 查询机构投屏列表
  getScreenList2(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCREEN_LIST2, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 投屏断开连接
  disconnectScreen2(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_SCREEN_DISCONNECT2, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 扫码登陆
  scanLogin2(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCAN_LOGIN2, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 通过uid查询投屏id
  getScreenIdByUid2(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_SCREEN_ID_BY_UID2, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取机构视图限制数量
  getViewLimit(postData) {
    return http.get(URL.API_SCREEN_LIMIT, postData)
  }
}
